const CONFIG = {
    firebaseApp: {
        apiKey: "AIzaSyB8_oEYko3thqr2jkX5DPzKZfreBMJ9kUE",
        authDomain: "mathwithmaki.firebaseapp.com",
        projectId: "mathwithmaki",
        storageBucket: "mathwithmaki.appspot.com",
        messagingSenderId: "365551277016",
        appId: "1:365551277016:web:d11aec7a832ad628ea98ad",
    },
    development: {
        on:
            window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1",
        firestorePort: 9292,
        webPort: 9191,
    },
    postSizeLimit: 500,
};

export default CONFIG;
